<template>
	<div>
		<div v-for="participant in appointment.participants">
			{{ participant }}
		</div>
	</div>
</template>

<script>
export default {

	props: {
		appointment: {
			type: Object,
			required: true,
		},
	}
}
</script>